export const IN_APP_REFERRALS_ROUTE = 'in-app-referrals';
